import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { CookieService } from 'ngx-cookie-service';
import { WalletService } from './wallet.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CustomUrlSerializer } from '../shared/models/UrlSerializer/custom-url-serializer';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private walletService: WalletService,
    private toast: ToastrService,
    private cookieService: CookieService
  ) {
    let userdata = this.userService.getToken();
    if (userdata.token) {
      this.userService.isLoggedIn = true;
    } else {
      this.userService.isLoggedIn = false;
    }

  }
  logOut() {
    if (!environment.production)
      console.log('logout')
    this.userService.deleteUserData();
    this.userService.deleteToken();
    this.userService.setUserData({});
    this.userService.setToken('');
    this.userService.isLoggedIn = false;
    localStorage.removeItem('tokenApp')
    if (!environment.production)
      console.log('RESOLVER 42: HIT LOG OUT EVENT');
    this.userService.logOutEventHit();
  }
  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  getParams() {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES')) {
        this.walletService.getCurrencies().toPromise().then((m: any) => {
          if (m.status === 200) {
            localStorage.setItem('OBSIDIAM-LOCAL-CURRENCIES', JSON.stringify(m.data));
          }
          let parameters = new URLSearchParams(window.location.search);
          this.activeRouter.queryParams.subscribe((a) => {
            // if (!environment.production)
              // console.log(a)
            let token = a.token || this.getParameterByName('token') || parameters.get('token');
            if (!this.cookieService.get('redirect') && CustomUrlSerializer.decript(this.router.url).indexOf('login') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('verify') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('welcome') == -1) {
              this.cookieService.set('redirect', CustomUrlSerializer.decript(this.router.url), new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
            }
            // if (!environment.production)
              // console.log('authguard', token, window.location.href, CustomUrlSerializer.decript(this.router.url), this.userService.isLoggedIn);
            if (token) {
              this.userService.getProfileData(token).toPromise().then((a: any) => {
                if (a.status === 200) {
                  const currency = m.data.find((a1) => a1.shortName === a.data.preferredCurrency);
                  a.data.preferredCurrency = currency || {};
                  let tokenData = { token: token, createdAt: new Date() }
                  let data = { ...a.data, ...tokenData };
                  this.userService.setToken(token);
                  this.userService.setUserData(data, true);
                  this.userService.startTokenTime();
                  this.userService.isLoggedIn = true;
                  this.userService.changeUserData();
                  resolve(true)
                } else {
                  resolve(false);
                }
              })
            } else {
              let userdata = this.userService.getToken();
              // console.log('authGuard token no token in url=>', userdata.token)
              if (!userdata.token) {
                resolve(false);
              } else {
                resolve(true);
              }
            }
          })


        });
      } else {
        let curen: any = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
        curen = curen ? JSON.parse(curen) : []
        let parameters = new URLSearchParams(window.location.search);
        this.activeRouter.queryParams.subscribe((a) => {
          // if (!environment.production)
            // console.log(a)
          let token = a.token || this.getParameterByName('token') || parameters.get('token');
          if (!this.cookieService.get('redirect') && CustomUrlSerializer.decript(this.router.url).indexOf('login') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('verify') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('welcome') == -1) {
            this.cookieService.set('redirect', CustomUrlSerializer.decript(this.router.url), new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
          }
          if (token) {
            this.userService.getProfileData(token).toPromise().then((a: any) => {
              if (a.status === 200) {
                let tokenData = { token: token, createdAt: new Date() }
                const currency = curen.find((a1) => a1.shortName === a.data.preferredCurrency);
                a.data.preferredCurrency = currency || {};
                let data = { ...a.data, ...tokenData };
                this.userService.setToken(token);
                this.userService.setUserData(data, true);
                this.userService.startTokenTime();
                this.userService.isLoggedIn = true;
                this.userService.changeUserData();
                resolve(true)
              } else {
                resolve(false);
              }
            })


          } else {
            let userdata = this.userService.getToken();
            // console.log('authGuard token is Currency=>', userdata.token)
            if (!userdata.token) {
              resolve(false);
            } else {
              resolve(true);
            }
          }
        });
      }
    });
  }
  async params() {
    let status = await this.getParams();
    return status;
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.cookieService.get('redirect') && CustomUrlSerializer.decript(this.router.url).indexOf('login') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('verify') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('welcome') == -1) {
      this.cookieService.set('redirect', CustomUrlSerializer.decript(this.router.url), new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
    }
    let a = this.userService.getToken();
    if (!a.token) {
      a = this.params()
    }
    // console.log('authGuard canactivate=>', a,)
    if (!a) {
      this.router.navigate(['login']);
      return false
    } else {
      return true;
    }
  }
}
